module.exports = __webpack_public_path__ + "static/media/usa-flag.8073d72d.jpg";